import { render } from "./StepBarWithIcon.vue?vue&type=template&id=2948c6c0"
import script from "./StepBarWithIcon.vue?vue&type=script&lang=js"
export * from "./StepBarWithIcon.vue?vue&type=script&lang=js"
script.render = render

export default script